(function () {
  function setOpen(card, open) {
    card.classList.toggle('is-open', open);
    var btn = card.querySelector('.hm-bun__toggle');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function onToggle(event) {
    var btn = event.currentTarget;
    var card = btn.closest('[data-hm-bun-card]');
    var root = btn.closest('[data-hm-bundles]');
    if (!card || !root) return;
    var open = !card.classList.contains('is-open');
    if (root.getAttribute('data-hm-one') === 'true') {
      root.querySelectorAll('[data-hm-bun-card]').forEach(function (other) {
        if (other !== card) setOpen(other, false);
      });
      if (!open && root.getAttribute('data-hm-keep') === 'true') open = true;
    }
    setOpen(card, open);
  }

  function bind(root) {
    if (!root || root.dataset.hmBunBound === '1') return;
    root.dataset.hmBunBound = '1';
    root.querySelectorAll('.hm-bun__toggle').forEach(function (btn) {
      btn.addEventListener('click', onToggle);
    });
  }

  function init(root) {
    if (root) {
      delete root.dataset.hmBunBound;
      bind(root);
      return;
    }
    document.querySelectorAll('[data-hm-bundles]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-hm-bundles]');
    if (root) init(root);
  });
})();
